<div class="accordion" [class.opened]="currentlyOpenedAccordion === 'account'">
  <div class="accordion-head" (click)="openAccordion('account')">
    <div class="accordion-head-top">
      <svg class="icon" width="16" height="12">
        <use xlink:href="#limit-icon"></use>
      </svg>

      <h3 class="title">Account settings</h3>
    </div>

    <div class="description">Add text</div>

    <div class="chevron">
      <svg class="icon" width="20" height="20">
        <use xlink:href="#chevron-small-down"></use>
      </svg>
    </div>
  </div>

  <div class="accordion-content">
    <app-email-account-client-settings
      [SMPTSettingsGroup]="SMPTSettingsGroup"
      [IMAPSettingsGroup]="IMAPSettingsGroup"></app-email-account-client-settings>
  </div>
</div>

<div class="accordion" [class.opened]="currentlyOpenedAccordion === 'limit'">
  <div class="accordion-head" (click)="openAccordion('limit')">
    <div class="accordion-head-top">
      <svg class="icon" width="16" height="12">
        <use xlink:href="#limit-icon"></use>
      </svg>

      <h3 class="title">Daily sending limit</h3>
    </div>

    <div class="description">
      Specify the maximum number of emails that can be sent via this email account
    </div>

    <div class="chevron">
      <svg class="icon" width="20" height="20">
        <use xlink:href="#chevron-small-down"></use>
      </svg>
    </div>
  </div>

  <div class="accordion-content">
    <app-email-account-limits [limitGroup]="sendingLimitGroup"></app-email-account-limits>
  </div>
</div>

<div class="accordion signature-editor" [class.opened]="currentlyOpenedAccordion === 'signature'">
  <div class="accordion-head" (click)="openAccordion('signature')">
    <div class="accordion-head-top">
      <svg class="icon" width="16" height="14">
        <use xlink:href="#brush-icon"></use>
      </svg>

      <h3 class="title">Signature</h3>
    </div>

    <div class="description">
      Add an email signature that will be shown at the end of each email
    </div>

    <div class="chevron">
      <svg class="icon" width="20" height="20">
        <use xlink:href="#chevron-small-down"></use>
      </svg>
    </div>
  </div>

  <div class="accordion-content">
    <app-email-signature-editor
      [initialContentHTML]="signature$ | async"
      #signatureEditor
      class="editor"></app-email-signature-editor>
  </div>
</div>

<div class="accordion" [class.opened]="currentlyOpenedAccordion === 'trachingDomain'">
  <div class="accordion-head" (click)="openAccordion('trachingDomain')">
    <div class="accordion-head-top">
      <svg class="icon" width="16" height="16">
        <use xlink:href="#globe-icon"></use>
      </svg>

      <h3 class="title">Custom tracking domain</h3>
    </div>

    <div class="description">
      See up to 20% improvement in deliverability when you add a custom domain
    </div>

    <div class="chevron">
      <svg class="icon" width="20" height="20">
        <use xlink:href="#chevron-small-down"></use>
      </svg>
    </div>
  </div>

  <div class="accordion-content">
    <app-email-account-tracking-domain
      [domainTrackingNameControl]="domainTrackingNameControl"></app-email-account-tracking-domain>
  </div>
</div>
